import React, { useState } from "react";
import * as Yup from "yup";
import { TextField } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import AuthBoxHeader from "../../components/authentication/AuthBoxHeader";
import AuthLayout from "src/layouts/AuthLayout";
import { useLocation, useNavigate } from "react-router";
import { Form, FormikProvider, useFormik } from "formik";
import authStores from "../../contexts/AuthProvider";
import { useSnackbar } from "notistack";
import { LoadingButton } from '@mui/lab';

const ResetPassword = () => {
   const authStore = authStores();
   const navigate = useNavigate();
   const { enqueueSnackbar } = useSnackbar();
   const { state } = useLocation();
   const [buttonLoading, setButtonLoding] = useState(false);

   const [passwordInput, setPasswordInput] = useState({
      password: "",
      showPassword: false,
   });
   const [confirmPasswordInput, setConfirmPasswordInput] = useState({
      password: "",
      showPassword: false,
   });
   // Password Field Data onChange
   const handlePasswordInputOnChange = (prop) => (event) => {
      setPasswordInput({ ...passwordInput, [prop]: event.target.value });
   };
   const handleConfirmPasswordInputOnChange = (prop) => (event) => {
      setConfirmPasswordInput({
         ...confirmPasswordInput,
         [prop]: event.target.value,
      });
   };
   // Password Field Visibility OnClick
   const handlePasswordInputVisibility = () => {
      setPasswordInput({
         ...passwordInput,
         showPassword: !passwordInput.showPassword,
      });
   };
   const handleConfirmPasswordInputVisibility = () => {
      setConfirmPasswordInput({
         ...confirmPasswordInput,
         showPassword: !confirmPasswordInput.showPassword,
      });
   };

   const forgetPasswordSchema = Yup.object().shape({
      password: Yup.string()
         .min(6, "Password can set of between 6 and 15 characters!")
         .max(15, "Password can set of between 6 and 15 characters!")
         .required("Password is required"),
      confirm_password: Yup.string()
         .oneOf([Yup.ref("password"), null], "Passwords must match")
         .required("Confirm Password is required")
   });

   const formik = useFormik({
      initialValues: {
         password: "",
         confirm_password: "",
         remember: true,
      },
      validationSchema: forgetPasswordSchema,
      onSubmit: async (values, { resetForm }) => {
         const forgotPasswordObj = {
            token: state?.token,
            password: values.password,
            confirmPassword: values.confirm_password,
            device: 3,
         };
         setButtonLoding(true)
         const [success, error] = await authStore.forgotPassword(forgotPasswordObj);
         if (success) {
            setButtonLoding(false)
            resetForm();
            navigate('/login');
            enqueueSnackbar(success.message, {
               variant: "success",
               anchorOrigin: { vertical: "top", horizontal: "right" },
               autoHideDuration: 2000,
            });
         } else {
            setButtonLoding(false)
            enqueueSnackbar(error.message, {
               variant: "error",
               anchorOrigin: { vertical: "top", horizontal: "right" },
               autoHideDuration: 2000,
            });
         }
      },
   });

   const { errors, touched, handleSubmit, getFieldProps } = formik;

   return (
      <>
         <AuthLayout>
            <FormikProvider value={formik}>
               <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                  <div className="auth_box">
                     <AuthBoxHeader
                        title={"Create New Password"}
                        instruction={
                           "Your new password must be different from the past one."
                        }
                     />
                     <TextField
                        id="resetPassword1"
                        type={passwordInput.showPassword ? "text" : "password"}
                        value={passwordInput.password}
                        onChange={handlePasswordInputOnChange("password")}
                        fullWidth
                        variant="outlined"
                        label="Password"
                        margin="normal"
                        {...getFieldProps("password")}
                        InputProps={{
                           endAdornment: (
                              <InputAdornment position="end">
                                 <IconButton
                                    sx={{ "&:hover": { bgcolor: "transparent" } }}
                                    disableRipple
                                    aria-label="toggle password visibility"
                                    onClick={handlePasswordInputVisibility}
                                    edge="end"
                                 >
                                    {passwordInput.showPassword ? (
                                       <VisibilityOffOutlinedIcon />
                                    ) : (
                                       <VisibilityOutlinedIcon />
                                    )}
                                 </IconButton>
                              </InputAdornment>
                           ),
                        }}
                        error={Boolean(touched.password && errors.password)}
                        helperText={touched.password && errors.password}
                     />
                     <TextField
                        id="resetPassword2"
                        type={confirmPasswordInput.showPassword ? "text" : "password"}
                        value={confirmPasswordInput.password}
                        onChange={handleConfirmPasswordInputOnChange("password")}
                        fullWidth
                        variant="outlined"
                        label="Confirm Password"
                        margin="normal"
                        {...getFieldProps("confirm_password")}
                        InputProps={{
                           endAdornment: (
                              <InputAdornment position="end">
                                 <IconButton
                                    sx={{ "&:hover": { bgcolor: "transparent" } }}
                                    disableRipple
                                    aria-label="toggle password visibility"
                                    onClick={handleConfirmPasswordInputVisibility}
                                    edge="end"
                                 >
                                    {confirmPasswordInput.showPassword ? (
                                       <VisibilityOffOutlinedIcon />
                                    ) : (
                                       <VisibilityOutlinedIcon />
                                    )}
                                 </IconButton>
                              </InputAdornment>
                           ),
                        }}
                        error={Boolean(touched.confirm_password && errors.confirm_password)}
                        helperText={touched.confirm_password && errors.confirm_password}
                     />
                     <LoadingButton
                        type='submit'
                        fullWidth
                        className="mt-5 text-capitalize text-white  app_text_16_semibold app_btn_lg"
                        loading={buttonLoading}
                        loadingPosition="end"
                        variant="contained"
                        sx={{
                           backgroundColor: "#FFBD05", boxShadow: "none" ,borderRadius: "8px", "&:hover": {
                           backgroundColor: "#FFBD05",
                           boxShadow: "none",
                           }
                        }}
                     >
                        Reset Password
                     </LoadingButton>
                  </div>
               </Form>
            </FormikProvider>
         </AuthLayout>
      </>
   );
};

export default ResetPassword;